import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LANG = window.location.pathname.startsWith("/admin") ? "fr" : "pl";
const LOCALE = LANG === "pl" ? "pl-PL" : "fr-FR";
export const api = axios.create({ baseURL: API, withCredentials: true, headers: { "X-Lang": LANG } });

const nf = new Intl.NumberFormat(LOCALE, { style: "currency", currency: "PLN", currencyDisplay: "narrowSymbol", maximumFractionDigits: 2 });
export const fmt = (n) => nf.format(Number(n || 0));
export const fdate = (d) => (d ? new Date(d).toLocaleDateString(LOCALE, { day: "numeric", month: "long", year: "numeric" }) : "—");

export function errMsg(e, fallback = "Une erreur est survenue. Veuillez réessayer.") {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || fallback;
}

export const fileToB64 = (file) =>
  new Promise((res, rej) => {
    if (file.size > 2_000_000) return rej(new Error("Fichier trop volumineux (2 Mo max)"));
    const r = new FileReader();
    r.onload = () => res({ name: file.name, type: file.type, data: r.result });
    r.onerror = rej;
    r.readAsDataURL(file);
  });

export const visitorId = () => {
  let v = localStorage.getItem("mb_vid");
  if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); localStorage.setItem("mb_vid", v); }
  return v;
};

export const UNIVERSES = {
  bois: { label: "Bois de chauffage", path: "/boutique?univers=bois" },
  poeles: { label: "Poêles & inserts", path: "/poeles" },
  granules: { label: "Granulés", path: "/granules" },
  accessoires: { label: "Accessoires", path: "/accessoires" },
  packs: { label: "Packs & offres", path: "/packs" },
};

export const STATUS = {
  nouvelle: "Nouvelle commande", confirmee: "Confirmée", preparation: "En préparation", prete: "Prête",
  en_livraison: "En livraison", livree: "Livrée", terminee: "Terminée", annulee: "Annulée", remboursee: "Remboursée",
};
export const STATUS_FLOW = ["nouvelle", "confirmee", "preparation", "prete", "en_livraison", "livree", "terminee"];
